
export class CommonSidebarConstants {
    public static NavigationTabMinWidth = 225;
    public static SearchTabMinWidth = 318;
    public static MeetingTabMinWidth = 358;
    public static ChatAiTabMinWidth = 400;

    public static PersonSidebarId = "sidebar-personal";
    public static OrganisationSidebarId = "sidebar-organisation";
}
